import Swal from "sweetalert2";

export const esnMenuItems  = [
  {
    title: "Tableau de bord",
    icon: "/assets/media/icons/tableau-de-bord.svg",
    iconHover: "/assets/media/icons/tableau-de-bord-hover.svg",
    route: "/accueil",
    requiresSubscription: true
  },
  {
   
    title: "Profil entreprise",
    icon: "/assets/media/icons/profil-entreprise.svg",
    iconHover: "/assets/media/icons/profil-entreprise-hover.svg",
    route: "/profil-entreprise/details-profil",
  },
  {
    title: "Talents",
    icon: "/assets/media/icons/candidats.svg",
    iconHover: "/assets/media/icons/candidats-hover.svg",
    route: "candidats/list-candidats",
    requiresSubscription: false
  },
  {
    title: "Messages",
    icon: "/assets/media/icons/messages.svg",
    iconHover: "/assets/media/icons/messages-hover.svg",
    route: "chat/chat-list",
    requiresSubscription: true
  },
  {
    title: "Appel d’offre",
    icon: "/assets/media/icons/appel-d’offre.svg",
    iconHover: "/assets/media/icons/appel-d’offre-hover.svg",
    onclick:()=>{
      Swal.fire({
        title: 'Fonctionnalité à venir prochainement. Merci pour votre compréhension',
        icon: 'warning',
        iconColor: '#63c3e8',
        confirmButtonColor: '#63c3e8',
        confirmButtonText: 'J’ai compris'
      })
    }
  },
  {
    title: "Offres du marché",
    icon: "/assets/media/icons/offre-d’emploi-(besoin-esn).svg",
    iconHover: "/assets/media/icons/offre-d’emploi-(besoin-esn)-hover.svg",
    route: "",
    children: [
      { title: "Liste", route: "esn-offres-emploi/list-offres", requiresSubscription: false },
      { title: "Archive", route: "esn-offres-emploi/archived", requiresSubscription: true}
    ]
  },
  {
    title: "Nos offres d’emploi",
    icon: "/assets/media/icons/nos-offres-d’emploi.svg",
    iconHover: "/assets/media/icons/nos-offres-d’emploi-hover.svg",
    requiresSubscription: true,
    route: "",
    children: [
      { title: "Liste", route: "offres-emploi/liste-offres-emploi" },
      { title: "Candidatures", route: "offres-emploi/candidature" }
    ]
  },
  {
    title: "Nos consultants",
    icon: "/assets/media/icons/nos-consultants.svg",
    iconHover: "/assets/media/icons/nos-consultants-hover.svg",
    route: "",
    requiresSubscription: true,
    children: [
      { title: "Liste", route: "consultants/liste" },
      { title: "Intercontrat", route: "consultants/intercontrat" }
    ]
  },
  {
    title: "Nos intervenants",
    icon: "/assets/media/icons/nos-intervenants.svg",
    iconHover: "/assets/media/icons/nos-intervenants-hover.svg",
    route: "intervenants",
    requiresSubscription: true,
  },
  {
    title: "Nos clients",
    requiresSubscription: true,
    icon: "/assets/media/icons/nos-clients.svg",
    iconHover: "/assets/media/icons/nos-clients-hover.svg",
    route: "",
    children: [
      { title: "Liste des clients", route: "nos-clients/liste" }
    ]
  },
  {
    title: "CRA",
    icon: "/assets/media/icons/cra.svg",
    iconHover: "/assets/media/icons/cra-hover.svg",
    requiresSubscription: true,
    requiresFeature: "CRA",
    route: "",
    children: [
      { title: "Liste Des Cras", route: "cra" },
      { title: "Workflow", route: "cra/list-workflow" }
    ]
  },
  {
    title: "Evaluation",
    requiresSubscription: true,
    icon: "/assets/media/icons/evaluation.svg",
    iconHover: "/assets/media/icons/evaluation-hover.svg",
    route: "",
    children: [
      { title: "Template évaluations", route: "evaluation/template-evaluation" },
      { title: "Liste évaluations", route: "evaluation/list" },
      { title: "PVs", route: "evaluation/pv" }
    ]
  },
  {
    title: "Entreprises",
    icon: "/assets/media/icons/entreprises.svg",
    iconHover: "/assets/media/icons/evaluation-hover.svg",
    route: "entreprises/list",
    requiresSubscription: false
  },
  {
    title: "Notre compte",
    icon: "/assets/media/icons/notre-compte.svg",
    iconHover: "/assets/media/icons/notre-compte-hover.svg",
    route: "notre-compte",
    condition: (hasSubscription: boolean) => hasSubscription
  },
  {
    title: "S’abonner",
    icon: "/assets/media/icons/s-abonner.svg",
    iconHover: "/assets/media/icons/s-abonner-hover.svg",
    route: "changer-offre",
    condition: (hasSubscription: boolean) => !hasSubscription
  },
];

export const clientMenuItems  = [
  {
    title: "Tableau de Bord",
    icon: "/assets/media/icons/tableau-de-bord.svg",
    route: "/dashbord"
  },
  {
    title: "Talents",
    icon: "/assets/media/icons/candidats.svg",
    route: "candidatsclientfinal"
  },
  {
    title: "Messages",
    icon: "/assets/media/icons/messages.svg",
    route: "chat/chat-list-client"
  },
  {
    title: "Nos Appels d’offre",
    icon: "/assets/media/icons/nos-appels-d’offre.svg",
    route: "",
    children: [
      { title: "Liste", route: "liste-appels-offres" },
      { title: "Candidatures", route: "liste-candidats" }
    ]
  },
  {
    title: "Nos consultants externes",
    icon: "/assets/media/icons/nos-consultants-externes.svg",
    route: "consultant-externe",
  },
  {
    title: "Nos consultants en attente",
    icon: "/assets/media/icons/nos-consultants-en-attente.svg",
    route: "consultant-attente",
  },
  {
    title: "Nos Projets",
    icon: "/assets/media/icons/nos-projets.svg",
    route: "projets"
  },
  {
    title: "Candidatures",
    icon: "/assets/media/icons/candidats.svg",
    route: "candidatures"
  },
  {
    title: "Nos salariés",
    icon: "/assets/media/icons/nos-salariés.svg",
    route: "employee",
  },
  {
    title: "Time Sheet",
    icon: "/assets/media/icons/time-sheet.svg",
    route: "",
    children: [
      { title: "Liste des Timesheet", route: "cra/liste-timesheet" },
      { title: "Workflow", route: "cra/workflow-Timesheet" }
    ]
  },
  {
    title: "Entreprises",
    icon: "/assets/media/icons/entreprises.svg",
    route: "entreprises/listclientfinal"
  },
  {
    title: "Paramètres",
    icon: "/assets/media/icons/paramètres.svg",
    route: "",
    children: [
      { title: "Type d’activité", route: "paramètres/type-activity-timesheet",
        requiresSubscription: true,
        requiresFeature: "CRA",
      },
      // { title: "Pages", route: "paramètres/pages" },
      { title: "Mailing", route: "paramètres/mailing" },
      { title: "Rôle et permission", route: "paramètres/permissions" },
/*       { title: "Mode de paiement", route: "paramètres/mode-payment" } */
    ]
  }
];
